module.exports = __webpack_public_path__ + "media/images/driving_school/stats-dcdf75664bf7b24cd6d02c33e4b5cb96.png";